export { default as theme } from "./theme";
export const nftaddress = "0x4904C7e9Ad36106F0F1bfCB194D3e131525B6F3e"
export const nftmarketaddress = "0xaa426F08b30bAE10dAE8123585a30B289Cc8B378"
